import ActionButtonModal from 'src/legacy/components/Modals/ActionButtonModal';

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onLeave: () => void;
}

/**
 * Confirms leaving app settings with unsaved changes. Matches the app-wide
 * unsaved-changes confirm that sidebar navigation and the builder modal show.
 */
export const UnsavedChangesDialog = ({
  isOpen,
  onCancel,
  onLeave,
}: UnsavedChangesDialogProps) => (
  <ActionButtonModal
    open={isOpen}
    onClose={onCancel}
    title="Unsaved changes"
    mainComponent="If you leave this page, your changes will be lost."
    cancelActionText="Cancel"
    positiveActionText="Leave page"
    positiveAction
    onPositiveActionPerformed={onLeave}
  />
);
